import React from 'react';
import BaseEntityList from './BaseEntityList';
import { EntityDesc } from './BaseAddEntityPopup/BaseAddEntityPopup';
import Terra from 'services/apis/terra/Terra';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { Environment } from 'data/terra/Environment';
import { fetchEnvironments } from 'containers/store/common/actions/FetchEnvironments';

function ListEnvironment() {
  const dispatch = useDispatch();
  const { environments } = useSelector((state: RootState) => state.common);

  return (
    <BaseEntityList<Environment>
      entityName="Environment"
      entities={environments}
      itemsPerRow={6}
      onEntitySelected={() => {}}
      onSaveEntity={async (desc: EntityDesc) => {
        return Terra.environment.addEnvironment(desc);
      }}
      onSaveEntityResult={result => {
        if (result.isSuccess()) {
          dispatch(fetchEnvironments());
        }
      }}
    />
  );
}

export default ListEnvironment;
